const PaginationLinkClickedEvent = new Event('livewire:pagination-clicked');

export default {
  PaginationLinkClickedEvent,
};
